(function() {
  function initButtons() {
    document.querySelectorAll('.button, button.submit, input[type="submit"], .product-card--add-to-cart-button-simple').forEach(btn => {
      if (btn.tagName.toLowerCase() === 'input') return;

      Array.from(btn.childNodes).forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
          const span = document.createElement('span');
          span.textContent = node.textContent;
          btn.insertBefore(span, node);
          btn.removeChild(node);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  const observer = new MutationObserver(mutations => {
    let shouldInit = false;
    mutations.forEach(m => {
      if (m.addedNodes.length) shouldInit = true;
    });
    if (shouldInit) initButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const dirs = ['top', 'right', 'bottom', 'left'];

  document.addEventListener('mouseenter', function(e) {
    const btn = e.target.closest('.button, button.submit, .product-card--add-to-cart-button-simple');
    if (!btn) return;

    const w = btn.offsetWidth;
    const h = btn.offsetHeight;
    const x = (e.clientX - btn.getBoundingClientRect().left - (w/2)) * (w > h ? (h/w) : 1);
    const y = (e.clientY - btn.getBoundingClientRect().top - (h/2)) * (h > w ? (w/h) : 1);
    const direction = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;

    btn.classList.add('no-transition');
    btn.classList.remove('in-top', 'in-right', 'in-bottom', 'in-left', 'out-top', 'out-right', 'out-bottom', 'out-left', 'is-hovered');
    btn.classList.add('in-' + dirs[direction]);

    void btn.offsetWidth;

    btn.classList.remove('no-transition');
    btn.classList.add('is-hovered');
  }, true);

  document.addEventListener('mouseleave', function(e) {
    const btn = e.target.closest('.button, button.submit, .product-card--add-to-cart-button-simple');
    if (!btn) return;

    const w = btn.offsetWidth;
    const h = btn.offsetHeight;
    const x = (e.clientX - btn.getBoundingClientRect().left - (w/2)) * (w > h ? (h/w) : 1);
    const y = (e.clientY - btn.getBoundingClientRect().top - (h/2)) * (h > w ? (w/h) : 1);
    const direction = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;

    btn.classList.remove('is-hovered');
    btn.classList.remove('in-top', 'in-right', 'in-bottom', 'in-left', 'out-top', 'out-right', 'out-bottom', 'out-left');
    btn.classList.add('out-' + dirs[direction]);
  }, true);
})();
